import { render, staticRenderFns } from "./LayQuestionBank.vue?vue&type=template&id=1e3c3580&scoped=true&"
import script from "./LayQuestionBank.vue?vue&type=script&lang=js&"
export * from "./LayQuestionBank.vue?vue&type=script&lang=js&"
import style0 from "./LayQuestionBank.vue?vue&type=style&index=0&id=1e3c3580&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3c3580",
  null
  
)

export default component.exports